export default __webpack_public_path__ + "static/media/oluwatomini.b51f5f40.png";